import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export const Route = createFileRoute('/unsubscribe')({
  head: () => ({
    meta: [
      { title: 'Meld av – VERQO' },
      { name: 'description', content: 'Meld deg av e-post fra VERQO.' },
      { name: 'robots', content: 'noindex' },
    ],
  }),
  component: UnsubscribePage,
})

function UnsubscribePage() {
  const [state, setState] = useState<'loading' | 'ready' | 'already' | 'invalid' | 'done' | 'error'>('loading')
  const [token, setToken] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get('token')
    setToken(t)
    if (!t) return setState('invalid')
    fetch(`/email/unsubscribe?token=${encodeURIComponent(t)}`)
      .then((r) => r.json())
      .then((j) => {
        if (j.valid) setState('ready')
        else if (j.reason === 'already_unsubscribed') setState('already')
        else setState('invalid')
      })
      .catch(() => setState('error'))
  }, [])

  async function confirm() {
    if (!token) return
    setBusy(true)
    try {
      const r = await fetch('/email/unsubscribe', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ token }),
      }).then((r) => r.json())
      if (r.success) setState('done')
      else if (r.reason === 'already_unsubscribed') setState('already')
      else setState('error')
    } catch {
      setState('error')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md rounded-2xl border border-white/10 bg-white/[0.03] p-8 text-center">
        <h1 className="text-xl font-semibold text-foreground">Meld av e-post fra VERQO</h1>
        {state === 'loading' && <p className="mt-3 text-sm text-muted-foreground">Laster…</p>}
        {state === 'ready' && (
          <>
            <p className="mt-3 text-sm text-muted-foreground">
              Bekreft at du ikke lenger vil motta e-post fra VERQO.
            </p>
            <button onClick={confirm} disabled={busy} className="btn btn-primary mt-6">
              {busy ? 'Melder av…' : 'Bekreft avmelding'}
            </button>
          </>
        )}
        {state === 'done' && (
          <p className="mt-3 text-sm text-muted-foreground">Du er meldt av. Takk.</p>
        )}
        {state === 'already' && (
          <p className="mt-3 text-sm text-muted-foreground">Denne adressen er allerede meldt av.</p>
        )}
        {state === 'invalid' && (
          <p className="mt-3 text-sm text-muted-foreground">Ugyldig eller utløpt lenke.</p>
        )}
        {state === 'error' && (
          <p className="mt-3 text-sm text-destructive">Noe gikk galt. Prøv igjen senere.</p>
        )}
      </div>
    </div>
  )
}
